function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 6C17 5.44772 16.5523 5 16 5C15.4477 5 15 5.44772 15 6V15C15 15.5523 15.4477 16 16 16C16.5523 16 17 15.5523 17 15V6ZM12.0271 10.1185C12.5067 9.84478 12.6737 9.23402 12.4 8.75435C12.1262 8.27468 11.5155 8.10774 11.0358 8.38147C8.03037 10.0966 6 13.3264 6 17.0321C6 22.5387 10.4807 26.995 16 26.995C21.5193 26.995 26 22.5387 26 17.0321C26 13.3714 24.0186 10.175 21.0733 8.44464C20.5971 8.16488 19.9843 8.32411 19.7045 8.80029C19.4248 9.27647 19.584 9.88929 20.0602 10.1691C22.4216 11.5564 24 14.112 24 17.0321C24 21.4264 20.4225 24.995 16 24.995C11.5775 24.995 8 21.4264 8 17.0321C8 14.0761 9.61744 11.4937 12.0271 10.1185Z",
  fill: "white"
});

function SvgPower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/Power.cd0a5f02.svg";
export { ForwardRef as ReactComponent };